import YieldIcon from './component.jsx'
export default YieldIcon



// WEBPACK FOOTER //
// ./src/components/YieldIcon/index.js